import './create-report-search-featured-card.scss';

import { first } from 'rxjs/operators';
import Component from 'vue-class-component';

import { ConditionReportDataStore, conditionReportSelectors } from '@skinsoft/entity/src/condition-report';
import { ItemDataStore } from '@skinsoft/entity/src/item';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { createTranslatedString, SearchFeatured, SearchFeaturedCard } from '@skinsoft/ui';
import { get, set } from 'lodash';
import { Watch } from 'vue-property-decorator';

@Component({
    components: {
        sSearchFeaturedCard: SearchFeaturedCard
    },
    props: ['searchFeatured', 'rounded', 'targetRouteName'],
    template: require('./create-report-search-featured-card.html'),
})
export class CreateReportSearchFeaturedCard extends ReactiveVue {

    public searchFeatured: SearchFeatured;
    public targetRouteName: string;

    public hasLastReport: boolean = false;

    private $itemDataStore: ItemDataStore
    private $conditionReportDataStore: ConditionReportDataStore

    public async createNewReport(fromLast: boolean = false) {
        const newReportId = fromLast ? await this.duplicateReportAndGetId(this.searchFeatured.lastConditionReportId)
            : await this.createReportAndGetId();

        this.$router.push(
            {
                name: this.targetRouteName,
                params: {
                    reportId: newReportId
                },
            });
    }

    public async createReportAndGetId(): Promise<string> {
        const report = await this.$conditionReportDataStore.create()
            .pipe(first())
            .toPromise();

        // Setting concerned item - temporary, TODO use right field when available
        report.conditionReportCS.comments = [];
        set(report, 'conditionReportCS.comments', [])
        set(report, 'conditionReportCS.linkableItem', { linkableItem: this.searchFeatured.itemId, type: this.searchFeatured.itemType })
        await this.$conditionReportDataStore.update(report.id, report).pipe(first()).toPromise();

        return report.id;
    }

    public async duplicateReportAndGetId(reportToDuplicateId: string): Promise<string> {
        const newReport = (await this.$conditionReportDataStore.duplicate(reportToDuplicateId)
            .pipe(first())
            .toPromise())
        return newReport.id;
    }

    public checkLastReport() {
        const lastReportId = get(this.searchFeatured, 'lastConditionReportId');
        if (lastReportId) {
            this.$conditionReportDataStore.fetchOne(lastReportId).subscribe(
                (conditionReport) => {
                    const isArchived: boolean = get(conditionReport, 'managementData.archived')
                    this.hasLastReport = !isArchived;
                }
            )
        } else {
            this.hasLastReport = false;
        }
    }

    @Watch('searchFeatured')
    private onSearchFeaturedChanged() {
        this.checkLastReport()
    }
}
